<style scoped>
    .customer-poptip-container{
        display: inline-block;
    }
    .customer{
        margin: 0;
    }
</style>
<style>
    .customer-poptip .ivu-poptip-body-content{
        max-height: inherit;
    }
    .customer-poptip .ivu-poptip-body{
        padding: 0;
        white-space: nowrap;
    }
</style>

<template>
    <div class="customer-poptip-container">
        <Poptip popper-class="customer-poptip" :trigger="trigger" @on-popper-show="getCustomerInfo">
            <div>
                <slot></slot>
            </div>
            <div class="customer-poptip-content" slot="content">
                <CustomerCard :customer="customer" v-if="customer.id"></CustomerCard>
                <Spin fix v-if="loading"></Spin>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import CustomerCard from "./card";
    export default {
        components: { CustomerCard },
        props: {
            customer_id: {
                type: Number,
                default: 0
            },
            trigger: {
                type: String,
                default: 'hover'
            }
        },
        data(){
            return {
                loading: false,
                customer: {}
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            getCustomerInfo(){
                if(this.customer.id) return;
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.common_customer_net_info, {
                    params: {
                        id: this.customer_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        let data = res.data;
                        this.customer = data.customer;
                    }else{
                        this.$Message.error(res.msg);
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Message.error(e.message);
                });
            }
        }
    }
</script>
